export enum Source {
    EXTRA = 'EXTRA',
    PARTNER = 'PARTENAIRE',
    REFEDU = 'REFEDU',
    STAFF = 'PERSONNEL',
    SUBSTITUTE = 'REMPLACANT',
    STUDENT = 'ELEVE',
    TEACHER = 'ENSEIGNANT',
  }
export default Source
